import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { UsePaginationInstanceProps, UsePaginationState } from "react-table";

import { BorderlessButton } from "components/customInputs/buttons/Button";

import "./ListPagination.css";

interface AdminPaginationPluginProps<
  D extends Record<string, unknown> = Record<string, unknown>
> extends Omit<UsePaginationInstanceProps<D>, "page" | "pageOptions">,
    UsePaginationState<D> {
  // Take most of the same options generated by useTable hooks
  // We don't need "page" (an array of rows on the page)
  // ... nor pageOptions
}
export interface ListPaginationProps extends AdminPaginationPluginProps {
  totalCount?: number;
  specimenCount?: number;
  label?: string;
  pageSizes?: number[];
  toggleAllRowsExpanded: Function;
  setToLocalStorage?: Function;
}

const ListPagination = ({
  nextPage,
  previousPage,
  gotoPage,
  canPreviousPage,
  canNextPage,
  totalCount = 0,
  specimenCount,

  pageIndex,
  pageCount,
  pageSize,
  pageSizes = [10, 25, 50, 100],
  setPageSize,

  toggleAllRowsExpanded,
  setToLocalStorage,
}: ListPaginationProps) => {
  const onClickNextPage = () => {
    toggleAllRowsExpanded(false);
    nextPage();
  };

  const onClickPreviousPage = () => {
    toggleAllRowsExpanded(false);
    previousPage();
  };

  const onChangePage = (page: number) => {
    toggleAllRowsExpanded(false);
    gotoPage(page);
  };

  return (
    <div className="ListPagination">
      <label className="ListPagination__selectLabel">
        Rows per page:
        <select
          value={pageSize}
          onChange={(e) => {
            setPageSize(parseInt(e.target.value));
            setToLocalStorage && setToLocalStorage(e.target.value);
          }}
        >
          {pageSizes.map((s) => (
            <option key={`${s}`} value={s}>
              {s}
            </option>
          ))}
        </select>
      </label>
      <small>
        {pageIndex * pageSize + 1} -{" "}
        {(pageIndex + 1) * pageSize > totalCount
          ? totalCount
          : (pageIndex + 1) * pageSize}{" "}
        of {totalCount} Cases
        {specimenCount && <> ({specimenCount} Specimen)</>}
      </small>
      <div className="ListPagination__navigation">
        <BorderlessButton
          onClick={() => onChangePage(0)}
          id="pagination-first-page"
          title="First"
          disabled={!canPreviousPage}
        >
          <FontAwesomeIcon icon="angles-left" />
        </BorderlessButton>
        <BorderlessButton
          onClick={onClickPreviousPage}
          id="pagination-previous-page"
          title="Previous"
          disabled={!canPreviousPage}
        >
          <FontAwesomeIcon icon="angle-left" />
        </BorderlessButton>
        <BorderlessButton
          onClick={onClickNextPage}
          id="pagination-next-page"
          title="Next"
          disabled={!canNextPage}
        >
          <FontAwesomeIcon icon="angle-right" />
        </BorderlessButton>
        <BorderlessButton
          onClick={() => onChangePage(pageCount - 1)}
          id="pagination-last-page"
          title="Last"
          disabled={!canNextPage}
        >
          <FontAwesomeIcon icon="angles-right" />
        </BorderlessButton>
      </div>
    </div>
  );
};

export default ListPagination;
